import { sanitizeHtml } from "@/lib/sanitize";

export function renderArticleHtml(article: any): string {
  const format = article?.content_format || "html";

  // tiptap: most reliable today is stored HTML (article.content)
  if (format === "tiptap") return sanitizeHtml(article?.content || "");

  // blocks: if content_blocks exists, you can quick fallback to content for now
  // (Phase 3/4 you can port blocks->html properly)
  if (format === "blocks") {
    return sanitizeHtml(article?.content || "");
  }

  // html
  return sanitizeHtml(article?.content || "");
}